__webpack_require__.p = "https://lassip-utfpr.github.io/webauspex/";